import { App, ConfigProvider } from "antd";
import React, { useEffect } from "react";
import Cat from "./webparts/components/Cat";
import { RootStoreContext } from "./webparts/root-store-context";
import RootStore from "./webparts/stores/root-store";
import { useDispatch } from 'react-redux';
import Headers from "../../../redux/Actions/Headers/Header";

const CATAppComponent = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      Headers.setHeader({
        title: "CAT - Community Allocator of Time"
      })
    );
    return () => {
      dispatch(Headers.resetHeader());
    };
  }, [dispatch]);

  return (
    <ConfigProvider
      theme={{
        token: {},
        components: {
          Button: {
            borderRadius: 4,
            colorPrimary: "#5a7890",
            colorPrimaryHover: "rgba(47, 75, 98, 1)",
            colorPrimaryActive: "rgba(47, 75, 98, 1)",
            colorPrimaryTextActive: "#ffffff",
          },
          Typography: {
            fontSize: 16,
          },
        },
      }}
    >
      <App>
        <RootStoreContext.Provider value={new RootStore()}>
          <Cat />
        </RootStoreContext.Provider>
      </App>
    </ConfigProvider>
  );
};

export default CATAppComponent;
